import ds from './DataSourceService'

const baseUrl = '/media'

const getMediaById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const deleteMediaById = id => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + id)
}

const getThumbnail = imgFileName => {
  return ds.apiClientThinkHome.get('/uploads/thumbnails/' + imgFileName)
}

const getParentGalleries = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/parent-galleries')
}

const addToGallery = (galleryId, mediaIds) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + galleryId + '/add-to-gallery',
    {
      mediaIds: mediaIds
    }
  )
}
const addToMultipleGalleries = (mediaId, galleryIds) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + mediaId + '/add-to-galleries',
    {
      galleryIds: galleryIds
    }
  )
}

const removeFromGallery = (galleryId, mediaId) => {
  return ds.apiClientThinkHome.delete(
    baseUrl + '/' + galleryId + '/remove-from-gallery',
    {
      data: {
        mediaId: mediaId
      }
    }
  )
}

const getGalleryContent = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/gallery-content')
}

const getMediaTypes = type => {
  let sufix = ``
  type ? (sufix = `?context=${type}`) : (sufix = '')
  return ds.apiClientThinkHome.get(baseUrl + '/types' + sufix)
}

const updateMedia = mediaItem => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + mediaItem.id, mediaItem)
}

const upload = files => {
  console.log('MediaService.upload', files)
  return ds.apiClientThinkHome.post(baseUrl + '/upload', files, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const getMediaFile = fileUrl => {
  return ds
    .apiClientThinkHome({
      method: 'get',
      url: fileUrl,
      responseType: 'arraybuffer'
    })
    .catch(e => {})
}

export default {
  getMediaById,
  deleteMediaById,
  getThumbnail,
  getParentGalleries,
  addToGallery,
  removeFromGallery,
  addToMultipleGalleries,
  getGalleryContent,
  getMediaTypes,
  updateMedia,
  upload,
  getMediaFile
}
